"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.denormalizeEntitiesByPaths = exports.buildEntityMappingsFromPaths = void 0;
var buildSchemaUtils_1 = require("../buildSchemaUtils");
var normalizr_1 = require("normalizr");
/*
    entityMapping is a structure like
     {
        Bar: {
            relatedCase: 'AppCase?REFONE'
        },
        AppCase: {
            processInstance: 'ProcessInstance?REFONE'
        }
    },
    of the form
    {
        [entityName]: {
            [fieldNameToExpand]: '<relatedEntity>?<dataType>'
        }
    }
*/
var buildEntityMappingsFromPaths = function (viewConfig, rootEntityType, paths, createRelatedEntitiesWithBackreferences) {
    if (createRelatedEntitiesWithBackreferences === void 0) { createRelatedEntitiesWithBackreferences = true; }
    var entities = {};
    paths.forEach(function (fexp) {
        var mappings = (0, buildSchemaUtils_1.getEntityRelationships)(viewConfig, rootEntityType, fexp);
        Object.keys(mappings).forEach(function (entityName) {
            if (!entities[entityName]) {
                entities[entityName] = {};
            }
            Object.keys(mappings[entityName]).forEach(function (k) {
                entities[entityName][k] = mappings[entityName][k];
            });
        });
    });
    if (createRelatedEntitiesWithBackreferences) {
        Object.values(entities).forEach(function (fieldSet) {
            Object.values(fieldSet).forEach(function (exp) {
                var relE = exp.split('?')[0];
                var fieldsInRelE = Object.values(viewConfig.entities[relE].fields);
                fieldsInRelE.forEach(function (f) {
                    if (!f.relatedEntity || !entities[f.relatedEntity]) {
                        return;
                    }
                    entities[relE][f.name] = "".concat(f.relatedEntity, "?").concat(f.dataType);
                });
            });
        });
    }
    return entities;
};
exports.buildEntityMappingsFromPaths = buildEntityMappingsFromPaths;
var denormalizeEntitiesByPaths = function (entities, paths, viewConfig, rootEntityType, rootEntityId) {
    var entityMappings = (0, exports.buildEntityMappingsFromPaths)(viewConfig, rootEntityType, paths, false);
    var builtSchema = (0, buildSchemaUtils_1.buildSchema)(entityMappings, viewConfig, true);
    if (!builtSchema[rootEntityType]) {
        builtSchema[rootEntityType] = new normalizr_1.schema.Entity(rootEntityType);
    }
    return (0, normalizr_1.denormalize)(rootEntityId, builtSchema[rootEntityType], entities);
};
exports.denormalizeEntitiesByPaths = denormalizeEntitiesByPaths;
//# sourceMappingURL=index.js.map